export interface ITemplateField {
  templateFieldId: string;
  templateId: string;
  fieldType: string;
  label: string;
  position: number;
  required: boolean;
  /**
   * `true` cuando este es EL campo cuyo valor la app pinta como subtitulo de
   * la credencial en su listado. Maximo uno por plantilla (lo garantiza el
   * API en una transaccion atomica al marcar otro); un campo cuyo `fieldType`
   * sea `protected` nunca puede llegar en `true` (el API responde 400 si se
   * intenta).
   */
  primaryField: boolean;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export class TemplateFieldModel {
  templateFieldId: string;
  templateId: string;
  fieldType: string;
  label: string;
  position: number;
  required: boolean;
  primaryField: boolean;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: ITemplateField) {
    this.templateFieldId = data.templateFieldId;
    this.templateId = data.templateId;
    this.fieldType = data.fieldType;
    this.label = data.label;
    this.position = data.position;
    this.required = data.required;
    this.primaryField = data.primaryField;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
